// Navigation section utility functions
// Centralizes logic for multi-section navigation behavior

/**
 * Determines if section labels should be displayed
 * @param {number} totalNavSectionSize - Total number of navigation sections
 * @param {string} label - The section label
 * @returns {boolean} Whether to show the section label
 */
export const shouldShowSectionLabel = (totalNavSectionSize, label) => {
  return totalNavSectionSize > 1 && label != undefined && label != '';
};

/**
 * Determines if titles should be hidden (noTitle prop)
 * @param {number} totalNavSectionSize - Total number of navigation sections
 * @returns {boolean} Whether titles should be hidden
 */
export const shouldHideTitle = (totalNavSectionSize) => {
  return totalNavSectionSize > 1;
};